

export const example_image_upload_handler =(blobInfo, success, failure, progress, token)=> {
    var xhr, formData;
    
    xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open('POST', `https://web-service.nashresra.com/api/v1/upload`);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.setRequestHeader("Authorization", token);

    xhr.upload.onprogress = function (e) {
        progress(e.loaded / e.total * 100);
    };

    xhr.onload = function() {
        var json;
        if (xhr.status === 403) {
            failure('HTTP Error: ' + xhr.status, { remove: true });
            return;
        }

        if (xhr.status < 200 || xhr.status >= 300) {
            failure('HTTP Error: ' + xhr.status);
            return;
        }

        json = JSON.parse(xhr.responseText);
        if (!json || typeof json.data.image_url != 'string') {
            failure('Invalid JSON: ' + xhr.responseText);
            return;
        }
        success(json.data.image_url);
    };

    xhr.onerror = function () {
        failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
    };

    formData = new FormData();
    formData.append('file', blobInfo.blob(), blobInfo.filename());
    xhr.send(formData);
};